import Promise from 'bluebird';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { NumberUtils } from '@bingads-webui-clientcenter/common-utils';

const { isValidWholeNumber } = NumberUtils;
const { AccountFeaturePilots } = Constants;

/**
 * Check if a feature is enabled for a particular account
 * @function
 * @param {object} jsDataCcRest jsData object
 * @param {object} options options
 * @param {String|Number} options.accountId account id
 * @param {String|Number} options.cid customer id
 * @param {string} options.featureName name of the feature to look up
 * @returns {Promise<bool>} A boolean value indication if the feature is enabled or not
 */
export const getAccountSingleFeatureStatus = (jsDataCcRest, { accountId, cid, featureName }) => {
  if (!isValidWholeNumber(accountId)) {
    return Promise.resolve(null);
  }

  // in support pages, cid has to be manually added
  const options = (cid !== undefined && isValidWholeNumber(cid)) ? { params: { cid } } : undefined;

  return jsDataCcRest.AccountFeatureSet.find(accountId, options)
    .then(res => res.features[AccountFeaturePilots[featureName]]);
};
